const DEFAULT_USER_STATE =   {
    isFetching: false,
    email: '',
    lastName: '',
    firstName: '',
    ssnBic: '', 
    tel: '',
    customerId: '',
    password: '',
    id:''
    };
    

export function user(state = DEFAULT_USER_STATE, action) {
    // console.log(action);
    switch (action.type) {
        case 'USER_CREATE_SUCCESS': {        
            return action.user;
        }

        default: {
            return state;
        }
    }
}

